import { InvalidHlsStream, isHlsStreamValid } from '../../Utility/Hls';
import { GenericVideo } from '../Generic';
import { SimpleHandlerConfig } from '../types';
import { GenericStreamHandler } from './GenericStream';

/**
 * HLS Handler for platforms, such as BrightSign, where HLS stream URLs can be used directly in
 * `<video>` tags without the need for an external library.
 */
export class HlsNativeStreamHandler extends GenericStreamHandler {
    protected _type: string;
    protected _videoId: string;
    protected _videoUrl: string;

    constructor(config: SimpleHandlerConfig) {
        super(config);
        this._videoId = config.videoUrl;
        this._videoUrl = config.videoUrl;
        this._type = 'hls_native';
    }

    protected async _createNewPlayer(): Promise<GenericVideo> {
        const isValidStream = await isHlsStreamValid(this._videoUrl);
        if (!isValidStream) {
            const message =
                'Unable to initialize hls stream because it is not properly formatted or unavailable';
            throw new InvalidHlsStream(message);
        }

        return super._createNewPlayer();
    }
}
